"use client";

import React from "react";
import SubPageLayout from "@/components/common/SubPageLayout";
import DiagramSection from "@/components/diagrams/DiagramSection";
import DiagramCard from "@/components/diagrams/DiagramCard";
import WedgeWireProfileDiagram from "@/components/diagrams/WedgeWireProfileDiagram";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { CURVED_SCREENS_CONTENT } from "./content";
export default function CurvedScreensPage() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, CURVED_SCREENS_CONTENT);
  const diagramTitle = pick(lang, {
    en: "Curved Wedge Wire V-Profile & Relief Geometry",
    zh: "弧形楔形丝 V 型型材截面与防堵释放角示意图",
    es: "Geometría de perfil en V y ángulo de alivio en cribas curvas",
    de: "V-Profil-Querschnitt und selbstreinigender Freiwinkel gekrümmter Spaltsiebe",
    fr: "Géométrie du profil en V et dépouillement arrière des grilles courbes",
    pt: "Geometria do perfil em V e ângulo de alívio em telas curvas"
  });
  const diagramLead = pick(lang, {
    en: "Cross-sectional schematic showing V-shaped surface profile wires, resistance-welded support rods, slot aperture, and widening relief channels for non-clogging hydrodynamic separation.",
    zh: "截面原理图展示表面 V 型截面丝、大电流熔焊支撑筋条、连续开孔缝隙以及避免卡塞的内宽自释放通道结构。",
    es: "Esquema en corte que ilustra los alambres en cuña en V superficiales, varillas de soporte soldadas por resistencia, apertura de ranura y canales de alivio ensanchados.",
    de: "Querschnittsschema mit Darstellung der V-förmigen Spaltsiebdrähte, widerstandsgeschweißten Tragstäbe, Spaltöffnungen und sich erweiternden Freiwinkeln zur verstopfungsfreien Entwässerung.",
    fr: "Schéma en coupe montrant les fils profilés en V, les tiges de support électrosoudées, l'ouverture de fente et les canaux d'évacuation élargis vers l'intérieur.",
    pt: "Esquema em corte demonstrando os arames em cunha com perfil em V, barras de suporte soldadas por resistência, fendas contínuas e canais de alívio alargados antientupimento."
  });
  const cardTitle = pick(lang, {
    en: "V-Wire Profile & Support Rod Cross-Section",
    zh: "V 型型材丝与支撑杆焊接截面",
    es: "Corte transversal de alambre en V y varilla de soporte",
    de: "Querschnitt: V-Draht und Tragstab",
    fr: "Coupe transversale : fil en V et tige support",
    pt: "Corte transversal: arame em V e barra de suporte"
  });
  const cardDesc = pick(lang, {
    en: "Resistance-welded intersections create rigid radial geometry while inward-widening relief allows immediate discharge of dewatered solids without mechanical blinding.",
    zh: "全熔电阻焊接形成高刚性径向弧形结构，后向逐渐扩宽的缝隙使通过表面筛口的微粒顺畅滑落，避免机械卡孔与结垢堵塞。",
    es: "Las uniones soldadas por resistencia crean una estructura rígida mientras el alivio ensanchado permite la descarga inmediata de sólidos sin cegamiento.",
    de: "Widerstandsgeschweißte Verbindungen sichern hohe Formsteifigkeit, während sich erweiternde Freiwinkel das ungehinderte Abführen von Feststoffen ohne Zusetzen ermöglichen.",
    fr: "Les liaisons soudées par résistance confèrent une grande rigidité radiale tandis que le dépouillement intérieur évite tout colmatage des solides filtrés.",
    pt: "As uniões soldadas por resistência criam alta rigidez radial enquanto o alívio interno alargado permite o descarte imediato dos sólidos sem cegamento mecânico."
  });
  const diagramSlot = <DiagramSection id="profile-diagram" title={diagramTitle} lead={diagramLead} tone="muted">
      <div className="max-w-2xl mx-auto">
        <DiagramCard index="01" badge="V-Profile" title={cardTitle} description={cardDesc}>
          <WedgeWireProfileDiagram variant="profile" />
        </DiagramCard>
      </div>
    </DiagramSection>;
  return <SubPageLayout content={content} diagram={diagramSlot} />;
}